import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Header.css";

function Header() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleRef = useRef(null);

  const handleRedirect = (direction) => {
    let navigatewindow = window.location.pathname.substring(0,3);
    if(navigatewindow==="/"){
      navigatewindow+="pl";
      
    }
    if(navigatewindow!=="/ua"&&direction===" "){
      navigatewindow="";
      console.log(navigatewindow);
      
    }
    
    navigate(navigatewindow+"/" + direction);
  };
  const handleRedirectlang = (lang)=>{
      if(lang==="ua"){
        navigate("/ua")
      }
      if(lang==="pl"){
        navigate("/")
      }
  }

  const expand = () => {
    setMenuOpen(true);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        toggleRef.current &&
        !toggleRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
if(window.location.pathname.substring(0,3)==="/pl"||window.location.pathname.substring(0,3)==="/"){
  return (
    <div className="App">
      <div className="header">
        <div className="img-container">
          <img src="/logo.webp" alt="logo" />
        </div>
        <div>
          <a  onClick={()=>handleRedirectlang("pl")}>PL</a>
          <a>    </a>
          <a onClick={()=>handleRedirectlang("ua")}>UA</a>
        </div>
        <div className="headerbut">
          
          <span onClick={() => handleRedirect(" ")} className="headerbutton">
            Strona Główna
          </span>
          <span onClick={() => handleRedirect("about")} className="headerbutton">
            O nas
          </span>
          <span onClick={() => handleRedirect("ofert")} className="headerbutton">
            Oferta
          </span>
          <span onClick={() => handleRedirect("price")} className="headerbutton">
            Cennik
          </span>


          <span onClick={() => handleRedirect("contact")} className="headerbutton">
            Kontakt
          </span>
        </div>

        <nav className="navbar">
          <div ref={toggleRef} className="menu-toggle" onClick={expand} id="menu-toggle">
            ☰
          </div>
          <ul ref={menuRef} className={`nav-links ${menuOpen ? "active" : ""}`} id="nav-links">
            <li>
              <span onClick={() => handleRedirect(" ")} className="headerbutton">
                Strona Główna
              </span>
            </li>
            <li>
              <span onClick={() => handleRedirect("about")} className="headerbutton">
                O nas
              </span>
            </li>
            <li>
              <span onClick={() => handleRedirect("ofert")} className="headerbutton">
                Oferta
              </span>
            </li>
            <li>
              <span onClick={() => handleRedirect("price")} className="headerbutton">
                Cennik
              </span>
            </li>
            <li>

            </li>
            <li>
              <span onClick={() => handleRedirect("contact")} className="headerbutton">
                Kontakt
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
}
  
  if(window.location.pathname.substring(0,3)==="/ua"){
    return (
      <div className="App">
        <div className="header">
          <div className="img-container">
            <img src="/logo.webp" alt="logo" />
          </div>
          <div>
          <a href="/">PL</a>
          <a>    </a>
          <a href="/ua">UA</a>
        </div>
          <div className="headerbut">
            <span onClick={() => handleRedirect(" ")} className="headerbutton">
            Головна
            </span>
            <span onClick={() => handleRedirect("about")} className="headerbutton">
            Про компанію
            </span>
            <span onClick={() => handleRedirect("ofert")} className="headerbutton">
            Пропозиція
            </span>
            <span onClick={() => handleRedirect("price")} className="headerbutton">
            Цінник
            </span>

            <span onClick={() => handleRedirect("contact")} className="headerbutton">
            Контакт
            </span>
          </div>
  
          <nav className="navbar">
            <div ref={toggleRef} className="menu-toggle" onClick={expand} id="menu-toggle">
              ☰
            </div>
            <ul ref={menuRef} className={`nav-links ${menuOpen ? "active" : ""}`} id="nav-links">
              <li>
                <span onClick={() => handleRedirect(" ")} className="headerbutton">
                Головна
                </span>
              </li>
              <li>
                <span onClick={() => handleRedirect("about")} className="headerbutton">
                Про компанію
                </span>
              </li>
              <li>
                <span onClick={() => handleRedirect("ofert")} className="headerbutton">
                Пропозиція
                </span>
              </li>
              <li>
                <span onClick={() => handleRedirect("price")} className="headerbutton">
                Цінник
                </span>
              </li>
              <li>
 
              </li>
              <li>
                <span onClick={() => handleRedirect("contact")} className="headerbutton">
                Контакт
                </span>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}

export default Header;
